import styled from "styled-components";

export const MessageTextSection = styled.section`
  overflow-wrap: anywhere;

  & a.message-content-link {
    color: inherit;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  & a.message-content-link:hover,
  & a.message-content-link:focus-visible {
    opacity: .82;
    outline: none;
  }
`;

export const LinkPreviewCard = styled.a`
  display: flex;
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.xxx_small }px;
  height: 64px;
  margin-top: ${({ theme }) => theme.spacing.xx_small }px;
  border: 1px solid ${({ theme }) => theme.glass.border };
  border-left: ${({ theme }) => theme.spacing.x_small }px solid ${({ theme }) => theme.colors.info.default };
  border-radius: ${({ theme }) => theme.border_radius.medium }px;
  background-color: ${({ theme }) => theme.colors.text.default }12;
  color: inherit;
  text-decoration: none;
  transition: background-color .16s ease, border-color .16s ease, transform .16s ease;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.colors.info.default }1A;
    border-color: ${({ theme }) => theme.colors.info.default }66;
    outline: none;
  }

  &:active {
    transform: scale(.99);
  }

  & > div.link-preview-info {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.x_small }px;
    padding: ${({ theme }) => theme.spacing.x_small }px;
    padding-left: ${({ theme }) => theme.spacing.none }px;
  }

  & > div.link-preview-icon {
    width: 56px;
    height: 100%;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.info.default }22;
    color: ${({ theme }) => theme.colors.info.default };
  }

  & > img {
    display: block;
    width: auto;
    height: 100%;
    max-width: none;
    align-self: stretch;
    justify-self: start;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.text.default }22;
  }

  & > div.link-preview-info > span,
  & > div.link-preview-info > strong,
  & > div.link-preview-info > small {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > div.link-preview-info > span {
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.info.default };
    text-transform: uppercase;
  }

  & > div.link-preview-info > strong {
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
  }

  & > div.link-preview-info > small {
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    opacity: .72;
  }
`;
